// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const barraskewda: PokeData = {
  "id": 847,
  "name": "barraskewda",
  "height": 13,
  "weight": 300,
  "base_experience": 172,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "fury-attack",
    "double-edge",
    "bite",
    "peck",
    "agility",
    "focus-energy",
    "crunch",
    "dive",
    "aqua-jet",
    "laser-focus",
    "throat-chop",
    "liquidation"
  ],
  "moves": [
    "bite",
    "peck",
    "agility",
    "crunch",
    "aqua-jet",
    "liquidation",
    "brine",
    "rain-dance",
    "hydro-pump",
    "water-spout",
    "aqua-tail",
    "life-dew",
    "bubble-beam"
  ],
  "evolution_chain": {
    "id": 445,
    "item": null,
    "species": [
      {
        "name": "arrokuda",
        "order": 846,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "barraskewda",
        "order": 847,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 846,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 73,
    "speed": 172,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
